import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { Shield, Mail, Phone, Calendar } from 'lucide-react';

const PRIMARY = '#c44569';
const BRAND_BG = 'linear-gradient(135deg,#c44569 0%,#cf6a87 100%)';

export default function AdminSettings() {
  const { user } = useAuth();

  const initials = user?.name
    ? user.name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
    : 'A';

  const info = [
    { label: 'Full Name',     value: user?.name,  Icon: Shield  },
    { label: 'Email',         value: user?.email, Icon: Mail    },
    { label: 'Phone',         value: user?.phone || '—', Icon: Phone },
    { label: 'Role',          value: user?.role,  Icon: Shield  },
    {
      label: 'Member Since',
      value: user?.created_at
        ? new Date(user.created_at).toLocaleDateString('en-US', { year:'numeric', month:'long', day:'numeric' })
        : '—',
      Icon: Calendar,
    },
  ];

  return (
    <div className="space-y-6 max-w-2xl">
      <div>
        <h1 className="text-3xl font-extrabold text-slate-900">Settings</h1>
        <p className="text-slate-500 text-sm mt-1">Admin profile &amp; system information</p>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">
        {/* Banner */}
        <div className="h-24" style={{ background: BRAND_BG }} />
        <div className="px-6 pb-6">
          <div className="-mt-10 mb-4">
            <div className="w-20 h-20 rounded-2xl bg-white shadow-lg border-4 border-white flex items-center justify-center text-2xl font-bold"
              style={{ color: PRIMARY }}>
              {initials}
            </div>
          </div>
          <h2 className="text-lg font-bold text-slate-900">{user?.name}</h2>
          <p className="text-slate-500 text-sm">{user?.email}</p>
          <span className="inline-block mt-2 text-xs px-3 py-1 rounded-full font-bold"
            style={{ background: '#fdf0f4', color: PRIMARY }}>
            Admin
          </span>
        </div>

        <div className="border-t border-slate-100">
          {info.map(({ label, value, Icon }) => (
            <div key={label} className="flex items-center gap-4 px-6 py-4 border-b border-slate-50 last:border-0 hover:bg-slate-50 transition">
              <div className="w-8 h-8 rounded-lg flex items-center justify-center shrink-0"
                style={{ background: '#fdf0f4', color: PRIMARY }}>
                <Icon size={16} strokeWidth={2.2} />
              </div>
              <div className="flex-1">
                <p className="text-xs text-slate-400">{label}</p>
                <p className="text-sm font-semibold text-slate-800">{value}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* System Info */}
      <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-6">
        <h3 className="text-base font-bold text-slate-800 mb-4">System Information</h3>
        <div className="grid grid-cols-2 gap-4 text-xs text-slate-600">
          <div className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-xl p-4 border border-slate-200">
            <p className="font-semibold text-slate-800 mb-1">Application</p>
            <p>EMS — Expense Management</p>
          </div>
          <div className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-xl p-4 border border-slate-200">
            <p className="font-semibold text-slate-800 mb-1">Technology Stack</p>
            <p>React.js · PHP · MySQL</p>
          </div>
          <div className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-xl p-4 border border-slate-200">
            <p className="font-semibold text-slate-800 mb-1">Authentication</p>
            <p>JWT Bearer Token · RBAC</p>
          </div>
          <div className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-xl p-4 border border-slate-200">
            <p className="font-semibold text-slate-800 mb-1">Admin Panel</p>
            <p>Role-protected · Verified</p>
          </div>
        </div>
      </div>
    </div>
  );
}
